var map = {
	"./1.jpeg": 9308,
	"./2.jpeg": 4812,
	"./3.jpeg": 6792,
	"./4.jpeg": 8460,
	"./5.jpeg": 817,
	"./6.jpeg": 3941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8623;